import React, { useRef, useEffect, useState } from "react";

import "../assets/css/Home.css";

import {
  PiArrowDownLight,
  PiGlobeLight,
  PiBrainLight,
  PiUsersLight,
  PiFireLight
} from "react-icons/pi";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/all";
import NoiseBackground from "../components/Background/NoiseBackground";
import NoiseBackgroundAbsolute from "../components/Background/NoiseBackgroundAbsolute";
import { useStateContext } from "../context/ContextProvider";
import About from "../components/Home/About";
import Contact from "../components/Home/Contact";
import Services from "../components/Home/Services";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function Home2({ routes }) {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const { isMobile, deviceSize, MARKER } = useStateContext();
  // const marker = MARKER;
  const marker = false;

  // SIDE NAV
  const [activeLink, setActiveLink] = useState("home");

  const links = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
  ];

  useEffect(() => {
    console.log("Current Device Size:", deviceSize);
    console.log("Is Mobile:", isMobile);
  }, [deviceSize, isMobile]);

  const handleLinkClick = (id) => {
    setActiveLink(id);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const observeOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id);
        }
      });
    }, observeOptions);
    links.forEach((link) => {
      const section = document.getElementById(link.id);
      if (section) {
        observer.observe(section);
      }
    });
    return () => {
      links.forEach((link) => {
        const section = document.getElementById(link.id);
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, [links]);

  // const model = useLoader(OBJLoader, greenBallObj);
  // const { nodes, materials } = useGLTF("../assets/objects/green-ball.obj");
  // const modelRef = useRef();
  // console.log("MODEL: ", model);

  // GSAP 
  const brandLogoRef = useRef(null);
  const oLogoContainerRef = useRef(null);
  const mottoRef = useRef(null);
  const contentRef = useRef(null);

  const oLogoRef = useRef(null);
  const oLogoTLRef = useRef(null);
  const oLogoTRRef = useRef(null);
  const oLogoBLRef = useRef(null);
  const oLogoBRRef = useRef(null);

  const oHeroRef = useRef(null);
  const oHeroTLRef = useRef(null);
  const oHeroTRRef = useRef(null);
  const oHeroBLRef = useRef(null);
  const oHeroBRRef = useRef(null);

  const leftCurtainRef = useRef(null);
  const rightCurtainRef = useRef(null);
  const scrollToRevealRef = useRef(null);
  const contentAboveRef = useRef(null);
  const contentBelowRef = useRef(null);
  const beforeContinueContainerRef = useRef(null);

  const sidebarRef = useRef(null);
  const headerRef = useRef(null);

  const hero1Ref = useRef(null);
  const hero2Ref = useRef(null);
  const hero3Ref = useRef(null);
  const heropRef = useRef(null);

  const homeSectionRef = useRef(null);

  const aboutcontent1Ref = useRef(null);
  const aboutpRef = useRef(null);

  const aboutSectionRef = useRef(null);
  const about1Ref = useRef(null);
  const about2Ref = useRef(null);
  const about3Ref = useRef(null);
  const about4Ref = useRef(null);
  const about1TextRef = useRef(null);
  const about2TextRef = useRef(null);
  const about3TextRef = useRef(null);
  const about4TextRef = useRef(null);

  const serviceSectionRef = useRef(null);
  const contactSectionRef = useRef(null);

  useEffect(() => {
    if (!leftCurtainRef.current || !rightCurtainRef.current) {
      console.error("Missing references for curtains.");
      return;
    }

    // INITIAL STATES
    gsap.set(leftCurtainRef.current, { x: "0%" });
    gsap.set(rightCurtainRef.current, { x: "0%" });
    gsap.set(scrollToRevealRef.current, { opacity: 1 });
    gsap.set(contentAboveRef.current, { opacity: 1 });
    gsap.set(brandLogoRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    });
    gsap.set(oLogoContainerRef.current, {
      zIndex: 10,
    });
    gsap.set(oLogoRef.current, {
      opacity: 1,
      position: "fixed",
      width: "92px",
      height: "92px",
      top: "50%",
      left: "50%",
      borderRadius: "100%",
      // boxShadow: "none",
      transform: "translate(30%, -150%)",
    });
    gsap.set(oLogoTLRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "46.5px",
      height: "46.5px",
      top: "0%",
      left: "0%",
      borderRadius: "100% 0 0 0",
      // boxShadow: "none",
    });
    gsap.set(oLogoTRRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "46.5px",
      height: "46.5px",
      top: "0%",
      left: "50%",
      borderRadius: "0 100% 0 0",
      // boxShadow: "none",
    });
    gsap.set(oLogoBLRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "46.5px",
      height: "46.5px",
      top: "50%",
      left: "0%",
      borderRadius: "0 0 0 100%",
      // boxShadow: "none",
    });
    gsap.set(oLogoBRRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "46.5px",
      height: "46.5px",
      top: "50%",
      left: "50%",
      borderRadius: "0 0 100% 0",
      // boxShadow: "none",
    });

    gsap.set(oHeroRef.current, {
      opacity: 0,
      scale: 10,
      width: "75px",
      height: "75px",
      borderRadius: "100%",
      background: "var(--primary)"
    });
    gsap.set(oHeroTLRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "38px",
      height: "38px",
      top: "0%",
      left: "0%",
      borderRadius: "100% 0 0 0",
      boxShadow: "none",
    });
    gsap.set(oHeroTRRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "38px",
      height: "38px",
      top: "0%",
      left: "50%",
      borderRadius: "0 100% 0 0",
      boxShadow: "none",
    });
    gsap.set(oHeroBLRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "38px",
      height: "38px",
      top: "50%",
      left: "0%",
      borderRadius: "0 0 0 100%",
      boxShadow: "none",
    });
    gsap.set(oHeroBRRef.current, {
      opacity: 1,
      background: "var(--primary)",
      width: "38px",
      height: "38px",
      top: "50%",
      left: "50%",
      borderRadius: "0 0 100% 0",
      boxShadow: "none",
    });

    gsap.set(mottoRef.current, {
      opacity: 0,
      scale: 0.5,
      textAlign: isMobile ? "center" : "left",
      transform: isMobile ? "translate(-50%, 100%)" : "translate(20%, 50%)",
    });
    gsap.set(sidebarRef.current, {
      opacity: 0,
    });
    gsap.set(headerRef.current, {
      width: "100vw",
      opacity: 1,
      scale: 0,
    });

    gsap.set(hero1Ref.current, {
      scale: 0,
      opacity: 1,
    });
    gsap.set(hero2Ref.current, {
      scale: 0,
      opacity: 1,
    });
    gsap.set(hero3Ref.current, {
      scale: 0,
      opacity: 1,
    });
    gsap.set(heropRef.current, {
      scale: 0,
      opacity: 1,
    });

    gsap.set(aboutcontent1Ref.current, {
      opacity: 1,
      scale: 0,
    });
    gsap.set(aboutpRef.current, {
      opacity: 0,
      scale: 1,
    });
    gsap.set(about1Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
      // width: deviceSize === "xl" ? "110px" : deviceSize === "lg" ? "110px" : deviceSize === "md" ? "60px" : "45px",
    });
    gsap.set(about2Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
    });
    gsap.set(about3Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
    });
    gsap.set(about4Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
    });
    gsap.set(about1TextRef.current, {
      opacity: 0,
    });
    gsap.set(about2TextRef.current, {
      opacity: 0,
    });
    gsap.set(about3TextRef.current, {
      opacity: 0,
    });
    gsap.set(about4TextRef.current, {
      opacity: 0,
    });

    // (#) CURTAIN | 10-90
    const curtain1Timeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentBelowRef.current,
        start: "10% top",
        end: "50% bottom",
        scrub: false,
        markers: marker,
        onEnter: () => curtain1Timeline.play(),
        onLeaveBack: () => curtain1Timeline.reverse(),
      },
    });
    // CURTAIN HALF | HIDE SCROLL TO REVEAL
    curtain1Timeline.to(leftCurtainRef.current, {
      x: "-30%",
      ease: "linear.inOut",
      duration: 2,
    });
    curtain1Timeline.to(
      rightCurtainRef.current,
      {
        x: "30%",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    curtain1Timeline.to(
      scrollToRevealRef.current,
      {
        opacity: 0,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    curtain1Timeline.to(
      oLogoRef.current,
      {
        opacity: 1,
        top: "50%",
        left: "50%",
        transform: "translate(30%, -150%)",
        ease: "linear.inOut",
        duration: 2
      },
      "<"
    );

    // CURTAIN FULL | OPACITY OF DODEAL
    const curtain2Timeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentBelowRef.current,
        start: "30% top",
        end: "90% bottom",
        scrub: false,
        markers: marker,
        onEnter: () => curtain2Timeline.play(),
        onLeaveBack: () => curtain2Timeline.reverse(),
      },
    });
    curtain2Timeline.to(leftCurtainRef.current, {
      x: "-90%",
      ease: "linear.inOut",
      duration: 2,
    });
    curtain2Timeline.to(
      rightCurtainRef.current,
      {
        x: "90%",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    curtain2Timeline.to(
      contentAboveRef.current,
      {
        opacity: 0,
        ease: "linear.inOut",
        duration: 2
      },
      "<"
    );
    // MOVE THE LOGO AND O | MOTTO OPACITY
    const mottoTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentBelowRef.current,
        start: "80% bottom",
        end: "bottom bottom",
        scrub: false,
        markers: marker,
        onEnter: () => mottoTimeline.play(),
        onLeaveBack: () => mottoTimeline.reverse(),
      },
    });
    mottoTimeline.to(brandLogoRef.current, {
      opacity: 1,
      scale: 1,
      transform: isMobile ? "translate(-50%, -100%)" : "translate(-130%, -50%)",
      ease: "linear.inOut",
      duration: 1,
    });
    mottoTimeline.to(
      oLogoRef.current,
      {
        opacity: 1,
        scale: 1,
        top: "50%",
        left: "50%",
        transform: isMobile
          ? "translate(30%, -300%)"
          : "translate(-170%, -150%)",
        width: "92px",
        height: "92px",
        borderRadius: "100%",
        backgroundImage: "none",
        boxShadow: "none",
        ease: "linear.inOut",
        duration: 1,
      },
      "<"
    );
    mottoTimeline.to(
      mottoRef.current,
      {
        opacity: 1,
        scale: 1.8,
        textAlign: isMobile ? "center" : "left",
        // transform: "translate(30%, 50%)",
        transform: isMobile ? "translate(-50%, 100%)" : "translate(30%, 50%)",
        ease: "linear.inOut",
        duration: 1,
      },
      "<"
    );
    // SEND ALL CONTENT TO LEFT
    const beforeContinueTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: beforeContinueContainerRef.current,
        start: "top top",
        end: "30% bottom",
        scrub: false,
        markers: marker,
        onEnter: () => beforeContinueTimeline.play(),
        onLeaveBack: () => beforeContinueTimeline.reverse(),
      },
    });
    beforeContinueTimeline.to(brandLogoRef.current, {
      opacity: 0,
      scale: 1,
      transform: isMobile ? "translate(-50%, -1000%)" : "translate(-130%, -500%)",
      ease: "linear.inOut",
      duration: 2,
    });
    beforeContinueTimeline.to(oLogoRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "50%",
      transform: isMobile
        ? "translate(50%, -50%)"
        : "translate(300%, 250%)",
      width: isMobile ? "200px" : "300px",
      height: isMobile ? "200px" : "300px",
      borderRadius: isMobile ? "100px 100px 0px 0px" : "150px 150px 0px 0px",
      // backgroundImage: "linear-gradient(to bottom right, var(--secondary), var(--primary)",
      // boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      boxShadow: "none",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(oLogoTLRef.current, {
      opacity: 1,
      scale: 1,
      top: "0%",
      left: "0%",
      width: isMobile ? "100px" : "150px",
      height: isMobile ? "100px" : "150px",
      borderRadius: "100% 0 0 0",
      // background: "var(--primary)",
      backgroundImage: "linear-gradient(to bottom, var(--secondary), var(--primary)",
      // boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      boxShadow: "none",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(oLogoTRRef.current, {
      opacity: 1,
      scale: 1,
      top: "0%",
      left: "50%",
      width: isMobile ? "100px" : "150px",
      height: isMobile ? "100px" : "150px",
      borderRadius: "0 100% 0 0",
      // background: "var(--primary)",
      backgroundImage: "linear-gradient(to bottom, var(--secondary), var(--primary)",
      // boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      boxShadow: "none",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(oLogoBLRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "0%",
      width: isMobile ? "100px" : "150px",
      height: isMobile ? "100px" : "150px",
      borderRadius: "0 0 0 100%",
      background: "transparent",
      boxShadow: "none",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(oLogoBRRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "50%",
      width: isMobile ? "100px" : "150px",
      height: isMobile ? "100px" : "150px",
      borderRadius: "0 0 100% 0",
      background: "transparent",
      boxShadow: "none",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(mottoRef.current, {
      opacity: 1,
      scale: 1.8,
      textAlign: isMobile ? "center" : "left",
      transform: isMobile ? "translate(-50%, -2000%)" : "translate(30%, -1800%)",
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(headerRef.current, {
      scale: 1,
      ease: "elastic.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(sidebarRef.current, {
      opacity: 1,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(heropRef.current, {
      opacity: 1,
      scale: 1,
      ease: "elastic.inOut",
      duration: 1,
    }, "<");
    beforeContinueTimeline.to(hero1Ref.current, {
      opacity: 1,
      scale: 1,
      ease: "elastic.inOut",
      duration: 1,
    }, ">");
    beforeContinueTimeline.to(hero2Ref.current, {
      opacity: 1,
      scale: 1,
      ease: "elastic.inOut",
      duration: 1,
    }, ">");
    beforeContinueTimeline.to(hero3Ref.current, {
      opacity: 1,
      scale: 1,
      display: "flex",
      ease: "elastic.inOut",
      duration: 1,
    }, ">");
    beforeContinueTimeline.to(oHeroRef.current, {
      opacity: 1,
      scale: 1,
      boxShadow: "none",
      width: "75px",
      height: "75px",
      borderRadius: "100%",
      background: "var(--primary)",
      ease: "elastic.inOut",
      duration: 2,
    }, "<");

    // SCROLL ABOUT CONTENT
    const scrollToAboutTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentRef.current,
        start: "top top",
        end: "center bottom",
        scrub: false,
        markers: marker,
        onEnter: () => scrollToAboutTimeline.play(),
        onLeaveBack: () => scrollToAboutTimeline.reverse(),
      },
    });
    // scrollToAboutTimeline.to(
    //   oLogoRef.current,
    //   {
    //     opacity: 1,
    //     scale: 1,
    //     top: "50%",
    //     left: "50%",
    //     transform: isMobile
    //       ? "translate(50%, -50%)"
    //       : "translate(300%, 0%)",
    //     width: isMobile ? "200px" : "300px",
    //     height: isMobile ? "100px" : "150px",
    //     borderRadius: isMobile ? "100px 100px 0px 0px" : "150px 150px 0px 0px",
    //     backgroundImage: "linear-gradient(to bottom right, var(--secondary), var(--primary)",
    //     boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
    //     zIndex: -1,
    //     ease: "elastic.inOut",
    //     duration: 2,
    //   },
    //   "<"
    // );
    // beforeContinueTimeline.to(
    //   sidebarRef.current,
    //   {
    //     opacity: 1,
    //     ease: "linear.inOut",
    //     duration: 1,
    //   },
    //   "<"
    // );
    scrollToAboutTimeline.to(heropRef.current, {
      opacity: 0,
      scale: 0,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    scrollToAboutTimeline.to(hero1Ref.current, {
      opacity: 1,
      scale: 0,
      ease: "linear.inOut",
      duration: 1,
    }, ">");
    scrollToAboutTimeline.to(hero2Ref.current, {
      opacity: 1,
      scale: 0,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    scrollToAboutTimeline.to(hero3Ref.current, {
      opacity: 0,
      scale: 0,
      display: "none",
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    scrollToAboutTimeline.to(aboutpRef.current, {
      opacity: 1,
      scale: 1,
      ease: "elastic.inOut",
      duration: 1,
    }, ">");
    scrollToAboutTimeline.to(aboutcontent1Ref.current, {
      opacity: 1,
      scale: 1,
      ease: "elastic.inOut",
      duration: 1,
    }, ">");
    scrollToAboutTimeline.to(oHeroRef.current, {
      opacity: 1,
      scale: 1,
      width: (deviceSize === "sm" || deviceSize === "xs") ? "360px" : deviceSize === "md" ? "480px" : deviceSize === "lg" ? "880px" : "880px",
      height: (deviceSize === "xs" || deviceSize === "sm") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
      borderRadius: "0%",
      background: "transparent",
      boxShadow: "none",
      ease: "linear.inOut",
      duration: 1,
    }, ">");
    scrollToAboutTimeline.to(oHeroTLRef.current, {
      opacity: 1,
      scale: 1,
      top: "0%",
      left: "25%",
      width: (deviceSize === "xs" || deviceSize === "sm") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
      height: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
      borderRadius: "110px 110px 0 0",
      background: "var(--primary)",
      boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 2,
    }, "<");
    scrollToAboutTimeline.to(oHeroTRRef.current, {
      opacity: 1,
      scale: 1,
      top: "0%",
      left: "75%",
      width: (deviceSize === "xs" || deviceSize === "sm") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
      height: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
      borderRadius: "110px 110px 0 0",
      background: "var(--primary)",
      boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 2,
    }, "<");
    scrollToAboutTimeline.to(oHeroBLRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "0%",
      width: (deviceSize === "xs" || deviceSize === "sm") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
      height: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
      borderRadius: "0 0 110px 110px",
      background: "var(--primary)",
      boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 2,
    }, "<");
    scrollToAboutTimeline.to(oHeroBRRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "50%",
      width: (deviceSize === "xs" || deviceSize === "sm") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
      height: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
      borderRadius: "0 0 110px 110px",
      background: "var(--primary)",
      boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      zIndex: -1,
      ease: "linear.inOut",
      duration: 2,
    }, "<");

    // SCROLL HALF CIRCLE ALONG WITH CONTENT REF 
    // const oHalfCircleWithTimeline = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: contentRef.current,
    //     start: "10% top",
    //     end: "bottom bottom",
    //     scrub: false,
    //     markers: marker,
    //     onEnter: () => oHalfCircleWithTimeline.play(),
    //     onLeaveBack: () => oHalfCircleWithTimeline.reverse(),
    //   },
    // });
    // oHalfCircleWithTimeline.to(
    //   oLogoContainerRef.current,
    //   {
    //     zIndex: 103,
    //     ease: "linear.inOut",
    //     duration: 1,
    //   }
    // );
    // oHalfCircleWithTimeline.to(
    //   oLogoRef.current,
    //   {
    //     opacity: 1,
    //     scale: 1,
    //     top: "50%",
    //     left: "50%",
    //     // transform: isMobile
    //     //   ? "translate(50%, 0%)"
    //     //   : "translate(00%, -50%)",
    //     transform: isMobile
    //       ? "translate(50%, 0%)"
    //       : "translate(300%, -400%)",
    //     width: isMobile ? "200px" : "300px",
    //     height: isMobile ? "100px" : "150px",
    //     borderRadius: isMobile ? "100px 100px 0px 0px" : "150px 150px 0px 0px",
    //     backgroundImage: "linear-gradient(to bottom right, var(--secondary), var(--primary)",
    //     boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
    //     zIndex: 103,
    //     ease: "elastic.inOut",
    //     duration: 2,
    //   }
    // );

    // SCROLL TO ABOUT SECTION
    const aboutCirclesTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: aboutSectionRef.current,
        start: isMobile ? "-600px top" : "-60px top",
        end: "top top",
        scrub: false,
        markers: false,
        onEnter: () => aboutCirclesTimeline.play(),
        onLeaveBack: () => aboutCirclesTimeline.reverse(),
      },
    });
    aboutCirclesTimeline.to(
      about1Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 1,
      },
    );
    aboutCirclesTimeline.to(
      about2Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 1.4,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about3Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 1.8,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about4Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 2.2,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about1TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 1,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about2TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 1.4,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about3TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 1.8,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about4TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 2.2,
      },
      "<"
    );

    // O IN ABOUT 
    // const oInAboutSectiontimeline = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: homeSectionRef.current,
    //     start: "top center",
    //     end: "90% bottom",
    //     scrub: 1,
    //     markers: marker,
    //   }
    // });
    // oInAboutSectiontimeline.to(oLogoRef.current, {
    //   // and hide relative o 
    // });

    // HIDE NAVBAR WHEN USER REACHED CONTACT SECTION 
    const navbarInContactTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: serviceSectionRef.current,
        start: "80% top",
        end: "center bottom",
        scrub: false,
        markers: marker,
        onEnter: () => navbarInContactTimeline.play(),
        onLeaveBack: () => navbarInContactTimeline.reverse(),
      },
    });
    navbarInContactTimeline.to(
      sidebarRef.current,
      {
        opacity: 0,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );

    // O IN ABOUT 
    // const aboutOTimeline = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: aboutSectionRef.current,
    //     start: "-300px top",
    //     end: "top top",
    //     scrub: false,
    //     markers: marker,
    //     onEnter: () => aboutOTimeline.play(),
    //     onLeaveBack: () => aboutOTimeline.reverse(),
    //   },
    // });
    // aboutOTimeline.to(oLogoRef.current, {
    //   opacity: 1,
    //   scale: 2,
    //   zIndex: 105,
    //   top: "50%",
    //   left: "50%",
    //   height: "75px",
    //   width: "75px",
    //   borderTopLeftRadius: "100px",
    //   borderTopRightRadius: "100px",
    //   borderBottomLeftRadius: "0px",
    //   borderBottomRighttRadius: "0px",
    //   // transform: isMobile
    //   //   ? "translate(3%, 213.5%)"
    //   //   : "translate(100%, 100%)",
    //   ease: "linear.inOut",
    //   duration: 1,
    // }, "<");

    // // ABOUT REF 


    // CLEAN UP SCROLL TRIGGER ON COMPONENT UNMOUNT
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [isMobile, deviceSize]);

  return (
    <div className="relative">
      <NoiseBackground />
      <div
        ref={oLogoContainerRef}
        className="w-[100vw] h-[100vh] fixed"
      >
        {/* O OVERALL */}
        {/* <div
          // ref={oLogoRef}
          style={{
            zIndex: 103,
          }}
          className="primary-bg"
        ></div> */}
        <div
          ref={oLogoRef}
          style={{
            zIndex: 103,
          }}
        >
          {/* Top Left Quarter */}
          <div
            ref={oLogoTLRef}
            className="quarter absolute"
          ></div>

          {/* Top Right Quarter */}
          <div
            ref={oLogoTRRef}
            className="quarter absolute"
          ></div>

          {/* Bottom Left Quarter */}
          <div
            ref={oLogoBLRef}
            className="quarter absolute"
          ></div>

          {/* Bottom Right Quarter */}
          <div
            ref={oLogoBRRef}
            className="quarter absolute "
          ></div>
        </div>
      </div>
      <div className="relative w-[100vw] h-full">
        {/* D HERO */}
        <div
          ref={brandLogoRef}
          className="fixed bg-white w-[215px] h-[275px] rounded-r-full"
          style={{
            zIndex: 9,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        ></div>
        {/* MOTTO */}
        <div
          ref={mottoRef}
          className="fixed uppercase text-2xl font-bold"
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, 0%)",
            zIndex: 9,
          }}
        >
          Your success
          <br />
          Our deal
        </div>
        {/* CONTENT ABOVE CURTAIN */}
        <div
          ref={contentAboveRef}
          className="content-above fixed top-0 left-0 w-[100vw] h-[100vh]"
          style={{
            zIndex: 100,
          }}
        >
          <div className="relative w-full h-full flex flex-col gap-5 items-center justify-between py-5">
            <div className="p-5"></div>
            <div className="flex flex-col gap-4 justify-center items-center">
              <div className="hero-brand grad-anim">DODEAL</div>
              <div
                ref={scrollToRevealRef}
                className="uppercase text-xs grad-anim"
              >
                Scroll to reveal
              </div>
            </div>
            <div className="p-5">
              <div className="p-2 border border-[var(--gold-3)] rounded-full">
                <PiArrowDownLight className="grad-anim" size={16} />
              </div>
            </div>
          </div>
        </div>
        {/* CURTAINS */}
        <div
          className="fixed w-[100vw] h-[100vh] overflow-hidden"
          style={{
            zIndex: 99,
          }}
        >
          {/* CURTAIN ANIMATION */}
          <div
            className="curtainBody absolute top-0 left-0 w-full h-full"
            style={{
              zIndex: 99,
            }}
          >
            {/* LEFT CURTAIN */}
            <div
              ref={leftCurtainRef}
              className="curtainContainer left-0"
              style={{
                transform: "translateX(0%)",
                zIndex: 99,
              }}
            >
              {Array.from({ length: 12 }).map((_, index) => (
                <div
                  key={index}
                  className="unCurtain"
                  style={{
                    animationDelay: `-${index * 0.1}s`,
                  }}
                ></div>
              ))}
            </div>
            {/* RIGHT CURTAIN */}
            <div
              ref={rightCurtainRef}
              className="curtainContainer right-0"
              style={{
                transform: "translateX(0%)",
                zIndex: 99,
              }}
            >
              {Array.from({ length: 12 }).map((_, index) => (
                <div
                  key={index}
                  className="unCurtain"
                  style={{
                    animationDelay: `-${index * 0.1}s`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
        {/* SECOND - DUMMY CONTENT - FOR THE DODEAL WITH MOTTO */}
        <div
          ref={contentBelowRef}
          className="w-[100vw] h-[250vh]"
          style={{
            zIndex: 90,
          }}
        ></div>
        {/* BEFORE CONTENT */}
        <div
          ref={beforeContinueContainerRef}
          className="relative w-full h-[100vh] flex flex-col items-center justify-center"
        ></div>
      </div>

      {/* HEADER */}
      <div
        ref={headerRef}
        className="fixed top-0 left-0 py-5"
        style={{
          zIndex: 105,
        }}
      >
        <Header routes={routes} />
      </div>

      {/* STICKY NAVBAR */}
      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 flex flex-col justify-center items-center h-screen z-40 transition-all duration-300 mx-2 ${!isMobile
          ? "w-28 lg:w-20" : "hidden"
          }`}
        style={{
          zIndex: 103,
        }}
      >
        <div className="text-white">
          <nav
            className={`relative flex flex-col gap-2 py-5 items-center transition-all duration-300`}
          >
            <span
              className={`absolute top-0 left-1/2 h-full w-2 blur-sm opacity-50 rounded-full bg-[#375a69] transform -translate-x-1/2 transition-all duration-300`}
              style={{
                transformOrigin: "center",
                // zIndex: -1
              }}
            ></span>
            {links?.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(link.id);
                }}
                className={`transition-all duration-300 ${activeLink === link?.id
                  ? `text-white font-bold text-lg scale-125`
                  : `text-[#727272] opacity-70 font-bold text-base hover:opacity-100`
                  }`}
              >
                {link?.label}
              </a>
            ))}
          </nav>
        </div>
      </div>

      {/* HOME HERO */}
      <div
        id="home"
        className="fixed w-[100vw] h-[100vh] top-0 left-0 flex flex-col pb-5 gap-5 items-center justify-between"
        style={{
          zIndex: 101,
        }}
      >
        <div className="h-[30px]"></div>
        <div className="padding-container text-center flex flex-col items-center justify-center">
          <div
            ref={hero1Ref}
            className="hero-text uppercase font-bold"
          >
            Every deal
          </div>
          <div
            ref={hero2Ref}
            className="hero-text uppercase font-bold"
          >
            starts with
          </div>
          <div className="flex items-center justify-center gap-2">
            <div
              ref={hero3Ref}
              className="hero-text uppercase font-bold"
            >
              D
            </div>
            <div
              ref={oHeroRef}
              className="mt-[5px]"
            >
              {/* Top Left Quarter */}
              <div
                ref={oHeroTLRef}
                className="quarter absolute left-0"
              ></div>

              {/* Top Right Quarter */}
              <div
                ref={oHeroTRRef}
                className="quarter absolute left-1/2"
              ></div>

              {/* Bottom Left Quarter */}
              <div
                ref={oHeroBLRef}
                className="quarter absolute w-1/2 h-1/2 bg-green-500 top-1/2 rounded-bl-full"
              ></div>

              {/* Bottom Right Quarter */}
              <div
                ref={oHeroBRRef}
                className="quarter absolute w-1/2 h-1/2 bg-yellow-500 top-1/2 left-1/2 rounded-br-full"
              ></div>
            </div>
          </div>
        </div>
        <div
          ref={heropRef}
          className="padding-container w-full flex justify-end"
          style={{
            color: "var(--l-gray)",
          }}
        >
          <div className="w-[300px] text-start text-sm me-[10%] pb-5">
            By merging innovation, adaptability, and excellence, we redefine
            how opportunities are discovered, developed, and delivered
            across industries.
          </div>
        </div>
      </div>

      {/* HOME HEIGHT DUMMY */}
      <div
        ref={contentRef}
        className="w-[100vw] h-[1000vh] relative top-0 overflow-x-hidden text-center py-5"
      ></div>

      {/* CONTINUITY CONTENT - ABOUT */}
      <div
        id="about"
        className="fixed w-[100vw] min-h-[100vh] top-0 left-0"
        style={{
          zIndex: 101,
        }}
      >
        <div className="flex flex-col pb-5 gap-5 items-center justify-between padding-container">

          <div className="h-[30px]"></div>
          <div className="grid grid-cols-4 gap-5 lg:gap-10 my-5 py-5">
            <div className="col-span-4 lg:col-span-3">
              <div
                ref={aboutcontent1Ref}
                className="hero-text uppercase font-bold text-center"
              >
                We Redefine Possibilities
              </div>
              <div className="hidden lg:flex h-[50px]"></div>
            </div>
            <div className="hidden md:flex lg:hidden col-span-2"></div>
            <div
              ref={aboutpRef}
              className="col-span-4 md:col-span-2 lg:col-span-1 text-sm text-[var(--l-gray)] flex items-end text-start"
            >
              At DODEAL, we merge innovation, strategy, and technology to deliver
              tailored solutions that empower businesses and individuals. Our
              data-driven approach ensures every opportunity is optimized for
              success, creating lasting value for our partners.
            </div>
          </div>
          {/* <FeaturesSection /> */}
          <div className="my-5 py-5 flex items-center justify-center">
            <div className="grid grid-cols-2 items-center justify-center">
              {/* 1T / 2I */}
              <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-start">
                <div
                  ref={about1Ref}
                  className="flex items-center justify-center"
                // className="w-[90px] md:w-[120px] lg:w-[220px] flex items-center justify-center"
                >
                  <div
                    ref={about1TextRef}
                    className="uppercase font-bold text-xs md:text-base lg:text-xl"
                  >
                    Worldwide
                    <br />
                    Approach
                  </div>
                </div>
                <div
                  className="primary-bg rounded-none rounded-t-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                  style={{
                    boxShadow:
                      "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <PiBrainLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                </div>
              </div>
              {/* 3T / 4I */}
              <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-start">
                <div
                  ref={about2Ref}
                  className="flex items-center justify-center"
                // w-[45px] md:w-[60px] lg:w-[110px]
                // className="w-[90px] md:w-[120px] lg:w-[220px] flex items-center justify-center"
                >
                  <div
                    ref={about2TextRef}
                    className="uppercase font-bold text-xs md:text-base lg:text-xl"
                  >
                    Experienced
                    <br />
                    Team
                  </div>
                </div>
                <div
                  className="primary-bg rounded-none rounded-t-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                  style={{
                    boxShadow:
                      "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <PiFireLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                </div>
              </div>
              {/* 1I / 2T */}
              <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-end">
                <div
                  className="primary-bg rounded-none rounded-b-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                  style={{
                    boxShadow:
                      "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <PiGlobeLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                </div>
                <div
                  ref={about3Ref}
                  className="flex items-center justify-center"
                >
                  <div
                    ref={about3TextRef}
                    className="uppercase font-bold text-xs md:text-base lg:text-xl"
                  >
                    Creative
                    <br />
                    Solutions
                  </div>
                </div>
              </div>
              {/* 3I / 4T */}
              <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-end">
                <div
                  className="primary-bg rounded-none rounded-b-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                  style={{
                    boxShadow:
                      "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <PiUsersLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                </div>
                <div
                  ref={about4Ref}
                  className="flex items-center justify-center"
                >
                  <div
                    ref={about4TextRef}
                    className="uppercase font-bold text-xs md:text-base lg:text-xl"
                  >
                    Blazing
                    <br />
                    Start
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        ref={aboutSectionRef}
        className="w-full min-h-[100vh] rounded-t-[50px]"
        style={{
          zIndex: 102,
        }}
      >
        <NoiseBackgroundAbsolute rounded={"rounded-t-[50px]"} />
        {/* ABOUT SECTION */}
        <div
          id="about"
          className="relative py-5 text-center min-h-[50vh] lg:min-h-[100vh] flex items-center justify-center"
        >
          {/* (2) HALF CIRCLE*/}
          <div
            className="absolute top-0 right-[7%] w-[200px] h-[100px] lg:w-[300px] lg:h-[150px] rounded-t-full"
            style={{
              backgroundImage:
                "linear-gradient(to bottom right, var(--secondary), var(--primary)",
              boxShadow:
                "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
              zIndex: -1,
            }}
          ></div>
          {/* <About /> */}
          <div className="w-full padding-container my-5 py-5 text-center">

          </div>
        </div>
        {/* SERVICES SECTION */}
        <div
          id="services"
          ref={serviceSectionRef}
          className="relative py-5 min-h-[100vh] flex items-center justify-center"
        >
          <Services />
        </div>
        {/* CONTACT SECTION */}
        <div
          ref={contactSectionRef}
          className="relative py-5 text-center min-h-[100vh] flex items-center justify-center"
        >
          <Contact />
        </div>


        {/* FOOTER */}
        <Footer />

      </div>
      {/* LEAVE IT FOR NOW  */}
      {/* <div className="relative w-full h-[5vh] flex flex-col items-center justify-center"></div> */}
    </div>
  );
}

export default Home2;
